@if (loyaltyStats) {
  <div class="badge badge-loyalty badge-primar px-2 clickable" (click)="openLoyaltyModal()">
    <i class="material-icons mr-1">emoji_events</i>
    <!-- <span *ngIf="bookingId">{{'SHARED.loyaltyPage.visit' | translate}}</span> -->
    {{ loyaltyStats.progress }} / {{ loyaltyStats.visitsNeeded }}
  </div>
}

@if (isLoyaltyPrizeBooking) {
  <div class="badge badge-loyalty badge-primar promo px-2">
    <i class="material-icons mr-1">emoji_events</i>
    {{ 'SHARED.loyaltyPage.prize' | translate }}
  </div>
}

<ng-template #dialog>
  @if (loyaltyForm.get('points')) {
    <div class="loyalty-modal md-content px-2 py-4">
      <i class="material-icons md-close" (click)="close()">close</i>
      <div class="md-header text-center px-5">
        <h3>Editar Fidelização</h3>
        <p class="text-small text-gray mb-2">{{ 'SHARED.loyaltyPage.editPoints' | translate }} {{clientName}} </p>
      </div>
      <form [formGroup]="loyaltyForm" class="md-body" >
        <div class="form-group text-center">
          <input type="number" [min]="0" [max]="loyaltyStats.visitsNeeded" formControlName="points" class="form-control m-auto" placeholder="Pontos" />
          @if (submitAttempted && loyaltyForm.invalid) {
            <div class="invalid-feedback d-block">
              {{ 'SHARED.loyaltyPage.editPointsInvalid' | translate }} {{ loyaltyStats.visitsNeeded }}
            </div>
          }
        </div>
      </form>
      <div class="md-actions text-center">
        <app-submit-btn btnCopy="{{ 'GENERAL.save' | translate }}" [hasError]="errorMsg" [loading]="saving" (click)="saveScore()" />
      </div>
    </div>
  }
</ng-template>
